
<div class="wrapper wrapper-full-page">
  <div class="page-header login-page header-filter" filter-color="black" style="background-image: url('./assets/img/login.jpg'); background-size: cover; background-position: top center;">
    <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
          <form class="form" #loginForm="ngForm" (ngSubmit)="changePass()">
            <div class="card card-login card-hidden">
              <div class="card-header card-header-warning text-center">
                <h4 class="card-title">Promena lozinke</h4>
              </div>
              <div class="card-body ">
                <span class="bmd-form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">lock_outline</i>
                      </span>
                    </div>
                    <input type="password" class="form-control" placeholder="Password..." name="password" required [(ngModel)]="password" pattern=".{4,}" required title="4 characters minimum">
                  </div>
                </span>
                <span class="bmd-form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">lock_outline</i>
                      </span>
                    </div>
                    <input type="password" class="form-control" placeholder="Confirm password..." name="confirmPassword" required [(ngModel)]="confirmPassword">
                  </div>
                </span>
              </div>
              <div class="card-footer justify-content-center">
                <button [disabled]="!loginForm.valid" class="btn btn-rose btn-link btn-lg" type="submit" >Potvrdi</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
